module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.8a36205b.ttf";